/// <amd-module name="typeahead/core/plugins/ExecutionHelper" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/typeahead/browser.d.ts" />
/// <reference path="../../../typings/typeahead/modulizr.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

import {ABTest} from "typeahead/core/ABTest";
import {Experiment} from "typeahead/core/Experiment";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

// prop mapping between StripingConfigration's properties and Context's properties

const supportedProperties = {
    clients : "clientId",
    deviceTypes : "deviceType",
    lobs : "lob",
    locales: "locale",
    packageTypes: "getShortPackageType",
    siteids : "siteid",
    tabs : "tab",
};

export const abTest = new ABTest();

export function evaluateExperiment(experiment: Experiment, abTestInstance = abTest): boolean {
    let evaluatedExp: Experiment = abTestInstance.getAndLog(experiment);
    return experiment.value !== undefined ? experiment.value === evaluatedExp.value : evaluatedExp.value > 0;
}

function getContextProp(configProp: string): string {
    return supportedProperties.hasOwnProperty(configProp) ? supportedProperties[configProp] : null;
}

function getApplicableConfiguration(
                    context: IContext, stripingConfigurations: IStripingConfiguration[]): IStripingConfiguration {
    let stripingConfiguration: IStripingConfiguration;
    for (let i: number = 0; i < stripingConfigurations.length; i++) {
        stripingConfiguration = stripingConfigurations[i];
        let isConfigApplicable: boolean = true;

        for (let configProp in stripingConfiguration) {
            if (configProp !== "experiment" && stripingConfiguration.hasOwnProperty(configProp) &&
                                                                            stripingConfiguration[configProp]) {
                let contextProp: string = getContextProp(configProp);
                if (contextProp && stripingConfiguration[configProp].indexOf(context[contextProp]) < 0) {
                    isConfigApplicable = false;
                    break;
                }
            }
        }
        if (isConfigApplicable) {
            return stripingConfiguration;
        }
    }
    return undefined;
}

function getEvaluateContext(context: IContext): IContext {
    let evaluated: IContext = $.extend({}, context);
    for (let propName of Object.getOwnPropertyNames(evaluated)) {
        if (typeof evaluated[propName] === "function") {
            evaluated[propName] = evaluated[propName]();
        }
    }
    return evaluated;
}

// the abTestInstance optional argument is for unit testing
export function shouldExecute(context: IContext, stripingConfigurations: IStripingConfiguration[],
                              abTestInstance = abTest): boolean {
    if (!stripingConfigurations || !stripingConfigurations.length ||  !context) {
        return true;
    }
    context = getEvaluateContext(context);
    let stripingConfig: IStripingConfiguration = getApplicableConfiguration(context, stripingConfigurations);

    if (stripingConfig) {
        let experiment = stripingConfig.experiment;
        if (experiment) {
            return evaluateExperiment(experiment, abTestInstance);
        } else {
            return true;
        }
    } else {
        return false;
    }
}

/**
 * NOTE: Please do not use this function
 * @returns {Experiment}
 */
export function doNotCallThisToGetEvaluatedExperimentInfo(context: IContext,
                                                          stripingConfigurations: IStripingConfiguration[],
                                                          abTestInstance = abTest): Experiment | undefined {
    let experiment: Experiment = undefined;
    if (context) {
        const stripingConfig: IStripingConfiguration = getApplicableConfiguration(context, stripingConfigurations);
        if (stripingConfig) {
            experiment = abTestInstance.getAndLog(stripingConfig.experiment);
        }
    }
    return experiment;
}
